export default "__VITE_ASSET__CcHFWlRh__"